import EditionSummary from './EditionSummary'

export default EditionSummary
